<template>
  <div class="content">
    <div class="md-layout">
      <div class="md-layout-item md-medium-size-100 md-size-75">
        <md-card>
          <md-card-header class="md-card-header-icon md-card-header-primary">
            <div class="card-text">
              <h4 class="title">
                {{ building.name }}&nbsp;
                <Badge v-if="building.stateId === 2" type="warning"
                  >Archived</Badge
                >
              </h4>
            </div>
            <edit-button
              :stateId="building.stateId"
              @edit-click="editBuilding"
            ></edit-button>
          </md-card-header>
          <md-card-content>
            <div class="md-layout">
              <div class="md-layout-item md-small-size-100 md-size-33">
                <address>
                  {{ building.address1 }}
                  <br />
                  <template v-if="building.address2">
                    {{ building.address2 }}
                    <br />
                  </template>
                  <template v-if="building.address3">
                    {{ building.address3 }}
                    <br />
                  </template>
                  <template v-if="building.city">
                    {{ building.city }}
                    <br />
                  </template>
                  <template v-if="building.county">
                    {{ building.county }}
                    <br />
                  </template>
                  <template v-if="building.country">
                    {{ building.country }}
                    <br />
                  </template>
                  {{ building.postcode }}
                </address>
              </div>
              <div class="md-layout-item md-small-size-100 md-size-33">
                <p>
                  <strong>Client</strong>
                  <br />
                  <router-link :to="{ name: 'Client' }">{{
                    building.clientName
                  }}</router-link>
                </p>
                <p>
                  <strong>Site</strong>
                  <br />
                  <router-link :to="{ name: 'Site' }">{{
                    building.siteName
                  }}</router-link>
                </p>
              </div>
            </div>
          </md-card-content>
        </md-card>
        <md-card>
          <md-card-header class="md-card-header-text md-card-header-primary">
            <div class="card-text">
              <h4 class="title">Plant</h4>
            </div>
            <add-button
              :visible="building.stateId == 1"
              @add-click="addPlant"
            ></add-button>
          </md-card-header>
          <md-card-content>
            <plantList></plantList>
          </md-card-content>
        </md-card>
      </div>
      <div class="md-layout-item md-medium-size-100 md-size-25"></div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import PlantList from "../plants/PlantList";
import { Badge } from "@/components";

export default {
  components: {
    PlantList,
    Badge
  },
  computed: {
    ...mapGetters({
      building: "data-management-client/building"
    })
  },
  created() {
    this.$store.dispatch(
      "data-management-client/getBuilding",
      this.$route.params.buildingId
    );
  },
  methods: {
    addPlant() {
      this.$router.push({ name: "Add Plant" });
    },
    editBuilding() {
      this.$router.push({
        name: "Edit Building",
        params: { buildingId: this.building.id }
      });
    }
  }
};
</script>

<style></style>
